export function canShowNoMatches(result) {
  return result?.comparison?.analysis_status === 'complete'
    && !result.comparison.issue_code
    && Boolean(result.ingredients_raw?.trim())
    && Array.isArray(result.comparison.matched)
    && result.comparison.matched.length === 0
    && Array.isArray(result.comparison.not_matched);
}

export function ingredientCheckNotice(result) {
  const status = result?.comparison?.analysis_status;
  const code = result?.comparison?.issue_code;
  const messages = {
    ingredient_text_uncertain: { title: 'Some Ingredient Text Could Not Be Read',
      text: result?.comparison?.notes || 'We could not read every ingredient confidently. Any matches shown cover only clearly read ingredients. Try a sharper, straight-on close-up of all ingredient sections.' },
    ingredient_source_invalid: { title: 'Upload the Ingredients List',
      text: 'Please upload the complete Ingredients section. Nutrition tables, guaranteed analysis, feeding guides and product photos cannot be used as ingredient lists.' },
    product_mismatch: { title: 'Product and Ingredient Images Do Not Match',
      text: 'Please upload the ingredient list for the exact product and formula pictured.' },
    product_unverified: { title: 'Confirm the Product and Formula',
      text: 'We could read ingredients, but could not verify that both images belong to the same product. Please include the product name with the ingredient list. Any matches shown apply only to the readable ingredients.' },
    legacy_unverified: { title: 'Historical Result',
      text: 'These saved results were created with an earlier ingredient reader and have not been reverified. They are shown for reference; running a new check is optional.' },
    ocr_busy: { title: 'Ingredient Reader Is Busy',
      text: 'Please try again shortly. This unsuccessful attempt does not use your free completed check.' },
    ocr_image_too_large: { title: 'Use a Smaller Ingredient Photo',
      text: 'Please upload a close-up ingredient image no larger than 6 megapixels.' },
  };
  if (messages[code]) return messages[code];
  if (status === 'complete' && !code && result?.ingredients_raw?.trim()) return null;
  if (!result?.ingredients_raw?.trim()) {
    return { title: 'Ingredient Check Could Not Be Completed',
      text: result?.comparison?.notes || 'We could not process the ingredient label. Please upload a clear photo of the complete list and try again.' };
  }
  if (status === 'incomplete') {
    return { title: 'Ingredient Check Is Incomplete',
      text: 'Only the readable portion of the label was checked. Any matches shown are partial results. Please upload the complete ingredient list.' };
  }
  return { title: 'Ingredient Check Could Not Be Completed',
    text: 'We could not verify a complete comparison against your report. Any matches shown are partial results. Please try scanning again.' };
}

export function ingredientCheckWarnings(result) {
  const normalize = text => String(text || '').trim().replace(/\s+/g, ' ').toLowerCase();
  const seen = new Set([normalize(ingredientCheckNotice(result)?.text)]);
  return (result?.flags || []).filter(flag => {
    const text = normalize(flag?.text);
    if (flag?.severity !== 'warn' || !text || seen.has(text)) return false;
    seen.add(text);
    return true;
  });
}
